module.exports = __webpack_public_path__ + "vodafone-logo-short.3e5256f627512b07a34fa6a2cadb34c9.svg";